import React from 'react';

import { SubscriptionPlans } from '@/components/SubscriptionCard/SubscriptionCard.utils';

export const Features = ({
  features,
}: {
  features: SubscriptionPlans[keyof SubscriptionPlans]['features'];
}) => {
  return (
    <ul className='flex flex-col gap-7 text-14px leading-9'>
      {features.map((feature) => (
        <li key={feature.label} className='flex gap-7 items-center text-14px'>
          <img
            src={
              feature.isAvailable
                ? '/icons/green-check.svg'
                : '/icons/gray-close.svg'
            }
            alt={feature.isAvailable ? 'Available' : 'Not available'}
          />
          <span
            className={`${feature.isAvailable ? 'text-customBlack' : 'text-lightText'}`}
          >
            {feature.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
